import { ReactNode, useEffect } from 'react'
import { FiAlertTriangle, FiX } from 'react-icons/fi'

import * as S from './style'

interface ConfirmModalProps {
  isOpen: boolean
  title: string
  description: ReactNode
  confirmText?: string
  cancelText?: string
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmModal = ({
  isOpen,
  title,
  description,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  loading = false,
  onConfirm,
  onCancel
}: ConfirmModalProps) => {
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !loading) {
        onCancel()
      }
    }

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, loading, onCancel])

  if (!isOpen) return null

  return (
    <S.Overlay role="presentation" onMouseDown={() => !loading && onCancel()}>
      <S.Dialog
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        aria-describedby="confirm-modal-description"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <S.CloseButton
          type="button"
          aria-label="Fechar"
          disabled={loading}
          onClick={onCancel}
        >
          <FiX />
        </S.CloseButton>

        <S.IconWrap aria-hidden="true">
          <FiAlertTriangle />
        </S.IconWrap>

        <S.Content>
          <S.Eyebrow>Atenção</S.Eyebrow>
          <S.Title id="confirm-modal-title">{title}</S.Title>
          <S.Description id="confirm-modal-description">
            {description}
          </S.Description>
        </S.Content>

        <S.Actions>
          <S.CancelButton type="button" disabled={loading} onClick={onCancel}>
            {cancelText}
          </S.CancelButton>
          <S.ConfirmButton type="button" disabled={loading} onClick={onConfirm}>
            {loading ? 'Excluindo...' : confirmText}
          </S.ConfirmButton>
        </S.Actions>
      </S.Dialog>
    </S.Overlay>
  )
}

export default ConfirmModal
